import { render, staticRenderFns } from "./ApproveList.vue?vue&type=template&id=178a7620"
import script from "./ApproveList.js?vue&type=script&lang=js&external"
export * from "./ApproveList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports